import { ICountry } from "../../models/country"

export enum SignUpTypeKeys {
  CLEAR_SIGN_UP_FIELDS = 'CLEAR_SIGN_UP_FIELDS',
  SET_SIGN_UP_EMAIL = 'SET_SIGN_UP_EMAIL',
  SET_SIGN_UP_PASSWORD = 'SET_SIGN_UP_PASSWORD',
  SET_SIGN_UP_REPEAT_EMAIL = 'SET_SIGN_UP_REPEAT_EMAIL',
  SET_SIGN_UP_REPEAT_PASSWORD = 'SET_SIGN_UP_REPEAT_PASSWORD',
  SET_SIGN_UP_NAME = 'SET_SIGN_UP_NAME',
  SET_SIGN_UP_LAST_NAME = 'SET_SIGN_UP_LAST_NAME',
  SET_SIGN_UP_DNI = 'SET_SIGN_UP_DNI',
  SET_SIGN_UP_PHONE = 'SET_SIGN_UP_PHONE',
  SET_SIGN_UP_COUNTRY = 'SET_SIGN_UP_COUNTRY',
  SET_SIGN_UP_CALLING_CODE = 'SET_SIGN_UP_CALLING_CODE',
  TOGGLE_COUNTRY_PICKER_MODAL = 'TOGGLE_COUNTRY_PICKER_MODAL',
  SET_SIGN_UP_TERMS = 'SET_SIGN_UP_TERMS',
  SET_SIGN_UP_BIRTH_DAY = 'SET_SIGN_UP_BIRTH_DAY',
  SET_SIGN_UP_BIRTH_MONTH = 'SET_SIGN_UP_BIRTH_MONTH',
  SET_SIGN_UP_BIRTH_YEAR = 'SET_SIGN_UP_BIRTH_YEAR',
  SET_SIGN_UP_GENDER = 'SET_SIGN_UP_GENDER',
  SET_SIGN_UP_IS_PRM = 'SET_SIGN_UP_IS_PRM',
  SET_SIGN_UP_SETTLEMENT = 'SET_SIGN_UP_SETTLEMENT',
  SET_SIGN_UP_ADDITIONAL_PHONE = 'SET_SIGN_UP_ADDITIONAL_PHONE',
  SET_SIGN_UP_ADDITIONAL_PHONE_CALLING_CODE = 'SET_SIGN_UP_ADDITIONAL_PHONE_CALLING_CODE',
  SET_SIGN_UP_ADDITIONAL_PHONE_COUNTRY = 'SET_SIGN_UP_ADDITIONAL_PHONE_COUNTRY',
  SIGN_UP = 'SIGN_UP',
  SIGNING_UP = 'SIGNING_UP',
  SIGN_UP_SUCCESSFUL = 'SIGN_UP_SUCCESSFUL',
  SIGN_UP_FAILED = 'SIGN_UP_FAILED'
}

export interface IClearSignUpFieldsAction {
  type: typeof SignUpTypeKeys.CLEAR_SIGN_UP_FIELDS
  [extraProps: string]: unknown
}

export interface ISetSignUpEmailAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_EMAIL
  payload: string
  [extraProps: string]: unknown
}

export interface ISetSignUpPasswordAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_PASSWORD
  payload: string
  [extraProps: string]: unknown
}

export interface ISetSignUpRepeatEmailAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_REPEAT_EMAIL
  payload: string
  [extraProps: string]: unknown
}

export interface ISetSignUpRepeatPasswordAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_REPEAT_PASSWORD
  payload: string
  [extraProps: string]: unknown
}

export interface ISetSignUpNameAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_NAME
  payload: string
  [extraProps: string]: unknown
}

export interface ISetSignUpLastNameAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_LAST_NAME
  payload: string
  [extraProps: string]: unknown
}

export interface ISetSignUpDNIAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_DNI
  payload: string
  [extraProps: string]: unknown
}

export interface ISetSignUpPhoneAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_PHONE
  payload: string
  [extraProps: string]: unknown
}

export interface ISetSignUpCountryAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_COUNTRY
  payload: ICountry
  [extraProps: string]: unknown
}

export interface ISetSignUpCallingCodeAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_CALLING_CODE
  payload: string
  [extraProps: string]: unknown
}

export interface IToggleCountryPickerModalAction {
  type: typeof SignUpTypeKeys.TOGGLE_COUNTRY_PICKER_MODAL
  [extraProps: string]: unknown
}

export interface ISetSignUpTermsAndConditionsAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_TERMS
  [extraProps: string]: unknown
}

export interface ISetSignUpBirthDayAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_BIRTH_DAY
  payload: string
}

export interface ISetSignUpBirthMonthAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_BIRTH_MONTH
  payload: string
}

export interface ISetSignUpBirthYearAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_BIRTH_YEAR
  payload: string
}

export interface ISetSignUpGenderAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_GENDER
  payload: string
}

export interface ISetSignUpIsPrmAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_IS_PRM
  payload: boolean
}

export interface ISetSignUpSettlementAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_SETTLEMENT
  payload: string
}

export interface ISetSignUpAdditionalPhoneAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_ADDITIONAL_PHONE
  payload: string
}

export interface ISetSignUpAdditionalPhoneCallingCodeAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_ADDITIONAL_PHONE_CALLING_CODE
  payload: string
}

export interface ISetSignUpAdditionalPhoneCountryAction {
  type: typeof SignUpTypeKeys.SET_SIGN_UP_ADDITIONAL_PHONE_COUNTRY
  payload: ICountry
}

export interface ISignUpAction {
  type: typeof SignUpTypeKeys.SIGN_UP
  [extraProps: string]: unknown
}

export interface ISetIsSigningUpAction {
  type: typeof SignUpTypeKeys.SIGNING_UP
  [extraProps: string]: unknown
}

export interface ISignUpSuccessfulAction {
  type: typeof SignUpTypeKeys.SIGN_UP_SUCCESSFUL
  [extraProps: string]: unknown
}

export interface ISignUpFailedAction {
  type: typeof SignUpTypeKeys.SIGN_UP_FAILED
  payload: any
  [extraProps: string]: unknown
}

export type SignUpActionTypes =
  | IClearSignUpFieldsAction
  | ISetSignUpEmailAction
  | ISetSignUpPasswordAction
  | ISetSignUpRepeatEmailAction
  | ISetSignUpRepeatPasswordAction
  | ISetSignUpNameAction
  | ISetSignUpLastNameAction
  | ISetSignUpDNIAction
  | ISetSignUpPhoneAction
  | ISetSignUpCountryAction
  | ISetSignUpCallingCodeAction
  | IToggleCountryPickerModalAction
  | ISetSignUpTermsAndConditionsAction
  | ISetSignUpBirthDayAction
  | ISetSignUpBirthMonthAction
  | ISetSignUpBirthYearAction
  | ISetSignUpGenderAction
  | ISetSignUpIsPrmAction
  | ISetSignUpSettlementAction
  | ISetSignUpAdditionalPhoneAction
  | ISetSignUpAdditionalPhoneCallingCodeAction
  | ISetSignUpAdditionalPhoneCountryAction
  | ISignUpAction
  | ISetIsSigningUpAction
  | ISignUpSuccessfulAction
  | ISignUpFailedAction
